module.exports = __webpack_public_path__ + "img/BlinkArt_Sword10_Bone.de180683.png";